module.exports = __webpack_public_path__ + "media/site/images/products/saas_actionplan-screen3-ec627b78a5b494b78fcbec7e69633c32.png";